export default "__VITE_ASSET__BcIz4MU___"